/** Parses "YYYY-MM-DD" string to UTC Date, or null if missing/invalid. */
function parseYYYYMMDD(str) {
  if (!str || typeof str !== "string") return null;
  const parts = str.split("-").map(Number);
  if (parts.length < 3 || !parts.every((n) => Number.isFinite(n))) return null;
  const [y, m, d] = parts;
  const date = new Date(Date.UTC(y, m - 1, d));
  return Number.isFinite(date.getTime()) ? date : null;
}


/** Default number of weeks when project dates are missing or invalid (~3 months). */
const DEFAULT_WEEK_COUNT = 12;
/** Milliseconds per day. */
const MS_PER_DAY = 24 * 60 * 60 * 1000;
/** Milliseconds per week. */
const MS_PER_WEEK = 7 * MS_PER_DAY;

function getStartOfWeek(date, startDay = 1) {
  const clone = new Date(date);
  const diff = (clone.getUTCDay() - startDay + 7) % 7;
  clone.setUTCDate(clone.getUTCDate() - diff);
  return clone;
}

export function getProjectWeekCount(project) {
  if (!project?.start_date || !project?.end_date) return DEFAULT_WEEK_COUNT;

  const startUTC = parseYYYYMMDD(project.start_date);
  const endUTC = parseYYYYMMDD(project.end_date);

  if (!startUTC || !endUTC || endUTC < startUTC) {
    return DEFAULT_WEEK_COUNT;
  }

  const weekStartUTC = getStartOfWeek(startUTC, project?.week_start_day ?? 1);

  const days = Math.floor((endUTC - weekStartUTC) / MS_PER_DAY) + 1;

  return Math.max(1, Math.ceil(days / 7));
}

export function getWeekRanges(project) {
  const count = getProjectWeekCount(project);
  const weeks = [];
  const startDay = project?.week_start_day ?? 1;
  let baseStart = parseYYYYMMDD(project?.start_date);
  if (!baseStart) {
    const today = new Date();
    baseStart = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
  }
  const weekStartUTC = getStartOfWeek(baseStart, startDay);

  const fmt = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });

  for (let i = 0; i < count; i++) {
    const start = new Date(weekStartUTC.getTime() + i * MS_PER_WEEK);
    const end = new Date(start.getTime() + 6 * MS_PER_DAY);

    weeks.push({
      start: fmt(start),
      end: fmt(end),
      label: `${fmt(start)} – ${fmt(end)}`,
      start_date: start.toISOString().split('T')[0],
    });
  }

  return weeks;
}